import BaseEnum from './BaseEnum';

class ClientsListSalesTerritory extends BaseEnum {
  fieldsMap = {
    'territory': 'Territory',
    'branch': 'Branch',
    'brand': 'Brand',
    'clientName': 'Client Name',
    'branchName': 'Branch Name',
    'address': 'Address',
    'clientTelephone': 'Client Telephone',
    'clientEmail': 'Client Email',
    'status': 'Status',
    'lastOrderDate': 'Last Order Date',
  }
}

export default ClientsListSalesTerritory.make();